class Form {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    })
  }

  init() {
    // File input name display
    const fileInputs = document.querySelectorAll('.file-input')

    fileInputs.forEach((input) => {
      input.addEventListener('change', function () {
        const fileName = this.files[0]?.name || 'Niciun fișier selectat'
        const field = this.closest('.field')
        const fileNameDisplay = field.querySelector('.control-filename')

        fileNameDisplay.classList.remove('is-hidden')
        fileNameDisplay.textContent = fileName
      })
    })

    // scroll to field.has-errors if existing
    const errorField = document.querySelector('.field.has-errors')
    if (errorField) {
      errorField.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }
}

const form = new Form()
export default form
